module.exports = __webpack_public_path__ + "img/second_.09dbbed0.jpg";